import { IModel, Model } from '@common/models/Model';

export interface IStoreCommunicationStatModel extends IModel {
  storeCommunicationStatId: number;
  storeId: number;
  unreadMessageCount: number;
  unreadMessageClientCount: number;
}

export class StoreCommunicationStatModel
  extends Model
  implements IStoreCommunicationStatModel
{
  storeCommunicationStatId: number;
  storeId: number;
  unreadMessageCount: number;
  unreadMessageClientCount: number;

  constructor(params?: Partial<IStoreCommunicationStatModel>) {
    super(params);
    this.storeCommunicationStatId = _.defaultTo(
      params?.storeCommunicationStatId,
      0,
    );
    this.storeId = _.defaultTo(params?.storeId, 0);
    this.unreadMessageCount = _.defaultTo(params?.unreadMessageCount, 0);
    this.unreadMessageClientCount = _.defaultTo(
      params?.unreadMessageClientCount,
      0,
    );
  }
}
